













































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dealTypeMap, currencyMap, totalClassList, exitTypeMap, permil } from '@/utils/finance';
import { projectDetailQuery, dealExit, sliceDealExit, fundListCommon } from '@/api/finance.js';
import exitDeal from './components/exitDeal.vue';
import moment from 'moment';

@Component({
  components: { exitDeal }
})
class ExitConfig extends Vue {
  classList: any[] = [];
  form: any = {};
  dealList: any[] = [];
  exitList: any[] = [];
  editExitData: any = {};
  projectId: number | null = null;
  editType: number | null = null; // 1.新建 2.编辑
  dealTypeMap = dealTypeMap;
  exitTypeMap = exitTypeMap;
  id: any = null;
  type: any = 'detail';

  rules: any = {
    sourceId: [{ required: true, message: '请选择退出', trigger: 'blur' }],
    dealType: [{ required: true, message: '请选择本轮交易类型', trigger: 'blur' }],
    exitType: [{ required: true, message: '请选择退出方式', trigger: 'blur' }],
    effectDate: [{ required: true, message: '请选择生效时间', trigger: ['blur', 'change'] }]
  };

  layout1 = { labelCol: { span: 8 }, wrapperCol: { span: 21 } };

  get dealData() {
    return this.$store.state.middlePageDetail.invest;
  }

  get title() {
    if (this.type === 'slice') {
      return this.editType === 1 ? '新建退出切片' : '编辑退出切片';
    } else {
      return this.editType === 1 ? '新建退出' : '编辑退出';
    }
  }

  get investDisabled() {
    return this.editType !== 1 || this.type === 'slice' || !this.form.effectDate;
  }

  get exitDealList() {
    return this.$store.state.middlePageDetail.exit.map(_ => {
      return {
        ..._,
        label: `${_.dealId}${_.classOfShare ? '-' + _.classOfShare : ''}-${_.deliveryDate}-${_.fund.name}`,
        id: _.dealId
      };
    });
  }

  get detail() {
    return this.type === 'slice' ? this.$store.state.middlePageSlice.detail : this.$store.state.middlePageDetail.detail;
  }

  get cnyCost() {
    const total = this.exitList.reduce((num, cur) => {
      if (cur.currency === 1 && +cur.cost) {
        num += +cur.cost;
      }
      return num;
    }, 0);
    return total;
  }

  get usdCost() {
    const total = this.exitList.reduce((num, cur) => {
      if (cur.currency === 2 && +cur.cost) {
        num += +cur.cost;
      }
      return num;
    }, 0);
    return total;
  }

  get usdAmount() {
    const total = this.exitList.reduce((num, cur) => {
      if (cur.currency === 2 && +cur.amount) {
        num += +cur.amount;
      }
      return num;
    }, 0);
    return total;
  }

  get cnyAmount() {
    const total = this.exitList.reduce((num, cur) => {
      if (cur.currency === 1 && +cur.amount) {
        num += +cur.amount;
      }
      return num;
    }, 0);
    return total;
  }

  get share() {
    const total = this.exitList.reduce((num, cur) => {
      if (+cur.shareNum) {
        num += +cur.shareNum;
      }
      return num;
    }, 0);
    return total;
  }

  async created() {
    let { projectId, id, type } = this.$route.query;
    this.projectId = +projectId;
    this.id = id;
    this.type = type;
    await this.fetchDetail();
    this.editType = this.$route.query.id ? 2 : 1; // 1/new 2/edit
    let {
      dealId,
      exitType,
      currency,
      remark,
      deliveryDate,
      fund = {},
      cost,
      amount,
      shareNum,
      investId,
      effectDate,
      allocatedAmount,
      exitValuation,
      dl,
      exitOpponent,
      investTotalShareNum
    } = this.editExitData || {};
    this.form = {
      dealType: 3,
      exitType,
      effectDate: effectDate ? moment(effectDate) : null,
      sourceId: dealId,
      exitOpponent
    };
    this.exitList = [
      {
        key: Math.random(),
        id: dealId,
        currency,
        remark,
        deliveryDate: deliveryDate ? moment(deliveryDate) : null,
        amount,
        shareNum,
        cost,
        fundId: fund.id || null,
        investId,
        allocatedAmount,
        exitValuation,
        dl,
        investTotalShareNum
      }
    ];
    if (effectDate) {
      this.fetchFundList();
    }
  }

  createNew() {
    this.exitList.push({
      key: Math.random(),
      id: null,
      currency: null,
      remark: '',
      deliveryDate: null,
      amount: '',
      shareNum: '',
      cost: '',
      fundId: null,
      investId: null
    });
  }

  effectDateChange(val) {
    this.fetchFundList();
  }

  exitTypeChange(val) {
    this.fetchFundList();
  }

  exitDealChange(val) {
    let { exitDealList } = this;
    let exit = exitDealList.find(_ => _.dealId === val);
    let {
      dealId,
      classOfShare,
      exitType,
      currency,
      remark,
      deliveryDate,
      fund = {},
      cost,
      amount,
      shareNum,
      investId,
      effectDate,
      exitOpponent,
      allocatedAmount,
      exitValuation,
      dl,
      investTotalShareNum
    } = exit;
    this.exitList = [
      {
        key: Math.random(),
        id: dealId,
        currency,
        remark,
        deliveryDate: deliveryDate ? moment(deliveryDate) : null,
        amount,
        shareNum,
        cost,
        fundId: fund.id || null,
        investId,
        allocatedAmount,
        exitValuation,
        dl,
        investTotalShareNum
      }
    ];
    this.form.effectDate = effectDate ? moment(effectDate) : null;
    this.form.exitOpponent = exitOpponent ? exitOpponent : '';
    this.fetchFundList();
  }

  async fetchDetail() {
    try {
      let { projectId, id, type } = this;
      this.$store.commit('middlePageDetail/setProjectId', projectId);
      this.$store.commit('middlePageSlice/setProjectId', projectId);
      await this.$store.dispatch('middlePageDetail/fetchDetail');
      await this.$store.dispatch('middlePageSlice/fetchSlice');

      if (type === 'detail' && id) {
        this.editExitData = this.$store.state.middlePageDetail.exit.find(_ => _.dealId === +id);
      } else if (type === 'slice' && id) {
        this.editExitData = this.$store.state.middlePageSlice.exit.find(_ => _.id === +id);
      }
    } catch (e) {
      console.log(e);
      // this.$message.error(e.message)
    }
  }

  async fetchFundList() {
    let {
      projectId,
      form: { effectDate, sourceId, exitType },
      editExitData: { dealId }
    } = this;
    if (!effectDate) {
      this.dealList = [];
      return;
    }
    let exitId = this.type === 'slice' ? sourceId : this.id;
    try {
      let res =
        (await fundListCommon({
          projectId,
          effectDate: effectDate.format('YYYYMMDD'),
          exitType: exitType,
          exitId
        })) || {};
      let dealList = (res.data || []).map(_ => ({
        label: `${_.investId}-${_.classOfShare}-${moment(_.deliveryDate).format('YYYYMMDD')}-${_.fundName}`,
        id: _.investId, // 对应的是invest的dealId
        disabled: false,
        // investTotalShareNum: this.$store.state.middlePageDetail.exit.find(_ => _.dealId === +id);
        ..._
      }));
      this.dealList = dealList;
    } catch (e) {}
  }

  setDealDisabled({ val, oldVal }) {
    let deal = this.dealList.find(_ => _.id === val);
    deal.disabled = true;
    let oldDeal = this.dealList.find(_ => _.id === oldVal);
    if (oldDeal) {
      oldDeal.disabled = false;
    }
  }

  handleOk() {
    (this.$refs.form as any).validate(valid => {
      if (valid) {
        this.checkDealValid();
      }
    });
  }

  checkDealValid() {
    //@ts-ignore
    this.$refs.exitDeal.forEach((comp, index) => {
      this.exitList[index].valid = false;
      comp.$refs.form.validate(val => {
        if (val) {
          this.exitList[index].valid = true;
          this.confirmValid();
        }
      });
    });
  }

  confirmValid() {
    let valid = this.exitList.every(_ => _.valid);
    if (valid) {
      this.confirmSave();
    }
  }

  confirmSave() {
    let title = `该条交易数据生效时间为：${this.form.effectDate.format('YYYY-MM-DD')}`;
    let { effectDate } = this.form;
    let showDateWarn = this.exitList.some(_ => {
      return Math.abs(effectDate.diff(_.deliveryDate, 'days')) > 90;
    });
    let content = h => {
      let nodeList: any[] = [];
      let dateNode = h('div', {}, '所选时间和生效时间间隔90天以上，请确认选择时间是否正确');
      if (showDateWarn) {
        nodeList.push(dateNode);
      }
      return h(
        'div',
        {
          attrs: {
            style: 'color: #ff4d4f'
          }
        },
        nodeList
      );
    };
    this.$confirm({
      title,
      content,
      okText: '确定',
      okType: 'danger',
      cancelText: '返回修改',
      icon: 'exclamation-circle',
      width: 600,

      onOk: () => {
        this.save();
      }
    });
  }

  async save() {
    let saveApi, params;
    let { form, exitList } = this;

    if (this.type === 'slice') {
      saveApi = sliceDealExit;
      params = exitList.map(_ => {
        let { deliveryDate, id, amount, shareNum, cost, remark, allocatedAmount, exitValuation } = _;
        return {
          id: this.id,
          manageType: 1,
          exitType: this.form.exitType,
          sourceId: form.sourceId,
          amount,
          shareNum,
          cost,
          remark,
          deliveryDate: moment(deliveryDate).format('YYYYMMDD'),
          effectDate: moment(form.effectDate).format('YYYYMMDD'),
          exitOpponent: this.form.exitOpponent,
          allocatedAmount,
          exitValuation
        };
      })[0];
    } else {
      saveApi = dealExit;
      params = exitList.map(_ => {
        let { deliveryDate, investId, id, amount, shareNum, cost, remark, allocatedAmount, exitValuation } = _;
        return {
          manageType: 1,
          exitType: this.form.exitType,
          investId,
          id,
          amount,
          shareNum,
          cost,
          remark,
          deliveryDate: moment(deliveryDate).format('YYYYMMDD'),
          effectDate: moment(form.effectDate).format('YYYYMMDD'),
          exitOpponent: this.form.exitOpponent,
          allocatedAmount,
          exitValuation
        };
      });
    }

    try {
      let res = await saveApi(params);
      if (res.code === 200) {
        this.$success({
          title: '提交成功',
          content: '交易记录提交成功',
          okText: '确定',
          onOk: () => {
            this.toMiddlePage();
          }
        });
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  deleteExit(index) {
    let detail = this.exitList[index];
    let isChange = false;
    for (let key in detail) {
      if (key !== 'key' && detail[key]) {
        isChange = true;
      }
    }
    if (isChange) {
      this.$confirm({
        title: '删除提醒',
        content: '将会删除此条记录,确定删除?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          let deleteItem = this.exitList.splice(index, 1);
          let deal = this.dealList.find(_ => _.id === deleteItem[0].investId);
          if (deal) {
            deal.disabled = false;
          }
        }
      });
    } else {
      let deleteItem = this.exitList.splice(index, 1);
      let deal = this.dealList.find(_ => _.id === deleteItem[0].investId);
      if (deal) {
        deal.disabled = false;
      }
    }
  }

  handleCancel() {
    //@ts-ignore
    this.$refs.form.clearValidate();
    // this.$emit('hide');

    this.$confirm({
      title: '取消提醒',
      content: '编辑的内容还未保存,确定取消编辑?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.toMiddlePage();
      }
    });
  }

  handleDel() {
    this.$confirm({
      title: '删除提醒',
      content: '将会删除此条记录,确定删除?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.delete();
      }
    });
  }

  async delete() {
    try {
      let res = await dealExit([
        {
          id: this.exitList[0].id,
          manageType: 2
        }
      ]);
      if (res.code === 200) {
        this.$message.success('删除成功');
        this.toMiddlePage();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  toMiddlePage() {
    localStorage.setItem('handleSubmit', new Date().getTime().toString());
    if (this.type === 'slice') {
      this.$router.push({ path: '/finance/middlePage/historySlice', query: { projectId: this.projectId + '' } });
    } else {
      this.$router.push({ path: '/finance/middlePage/detail', query: { projectId: this.projectId + '' } });
    }
  }

  permil(val) {
    return permil(val, 10, true);
  }

  clearDate() {
    if (this.form.effectDate) {
      this.$message.error('选中日期无当前交易切片，请重新选择', 4);
      this.form.effectDate = null;
    }
  }
}

export default ExitConfig;
